import {classNames, React, pluralize, observer, Fragment, Popover2} from '@api'
import {Button, Popover, Menu, MenuItem, MenuDivider} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {Tooltip} from '@material-ui/core'
import {useStores} from '@modules/VipLocalStore'
import {NumberBadge} from 'centric-ui-components'
import * as css from './PerspectiveButtons.css'
import {CatalogPerspectiveConfig} from '@stores'

export const PerspectiveButtons = observer(function PerspectiveButtons() {
  const {
    strings, catalog: {itemCountForPerspective, onSetPerspective, perspectiveId, showPerspectiveButtons, headerPerspectives, filteredOfflineItemsIgnorePerspectives, showUnsavedChangesButton}, filter
  } = useStores()

  if (!showPerspectiveButtons) {
    return null
  }

  return <div className={css.root}>
    <UnsavedChangesPerspectiveButton/>
    {headerPerspectives.map((p, i) => {
       const active = p.id == perspectiveId,
         count = itemCountForPerspective(p)

       return (
         <Fragment key={p.id}>
           <Tooltip2 content={p.label} placement='bottom'>
             <Button active={active}
                     icon={p.icon}
                     minimal
                     data-type='PerspectiveButton'
                     data-perspective={p.id}
                     className={css.button}
                     onClick={onSetPerspective(p)}
                     text={<span className={css.text}>
                    {<span className={css.label}>{pluralize(p.label)}</span>}
                       <PerspectiveCountLabel perspective={p} count={_.isNaN(count) ? null : count}/>
                    </span>}
             />
           </Tooltip2>
         </Fragment>)
     })}
    {filteredOfflineItemsIgnorePerspectives.length && filter.hasLoaded ? <OfflineItemsPerspectiveButton/> : null}
  </div>
})

export const PerspectiveCountLabel = observer<{ count?, perspective?: CatalogPerspectiveConfig }>(({count, perspective}) => {
  return <NumberBadge className={css.count} children={count} style={{background: perspective?.background}}/>
})

export const OfflineItemsPerspectiveButton = observer(() => {
  const {
    catalog: {strings, filteredOfflineItemsIgnorePerspectives, toggleShowOnlyOfflineCatalogItems, settings: {showOnlyOfflineItems}}
  } = useStores()
  return (
    <Tooltip2 content={strings.offlineItems} placement='bottom'>
      <Button className={css.button}
              active={showOnlyOfflineItems}
              minimal
              data-perspective={'OfflineItems'}
              data-type='PerspectiveButton'
              onClick={toggleShowOnlyOfflineCatalogItems}
              text={<span className={css.text}>
                                         <span className={css.label}>Pending Items</span>
                                         <NumberBadge className={classNames(css.count, css.offlineItems)} children={filteredOfflineItemsIgnorePerspectives.length}/>
                                       </span>}
      />
    </Tooltip2>)
})

export const UnsavedChangesPerspectiveButton = observer(() => {
  const {
    strings, catalog: {showUnsavedChangesButton, catalogItemsWithUnsavedChanges, toggleShowOnlyItemsWithChanges, settings: {showOnlyItemsWithChanges, autoSaveInlineChanges}, cancelAllOfflineChanges, saveAllOfflineChanges, toggleAutoSaveInlineChanges},
  } = useStores()

  if (!showUnsavedChangesButton) return null

  return (<Popover2
    interactionKind='click'
    position='bottom'
    content={<Menu>
      {catalogItemsWithUnsavedChanges.length > 0 &&
	   <Fragment>
		   <MenuItem onClick={toggleShowOnlyItemsWithChanges} icon={showOnlyItemsWithChanges ? 'tick' : 'blank'} text={'Show Only Items with Changes'}/>
		   <MenuItem onClick={cancelAllOfflineChanges} icon={'blank'} text={`Cancel All`}/>
		   <MenuItem onClick={saveAllOfflineChanges} icon={'blank'} text={`Save All`}/>
		   <MenuDivider/>
	   </Fragment>}
      <MenuItem onClick={toggleAutoSaveInlineChanges} icon={autoSaveInlineChanges ? 'tick' : 'blank'} text={'Auto-Save Changes'}/>
    </Menu>}
  >
    <Button className={css.button}
            active={showOnlyItemsWithChanges}
            minimal
            data-perspective={'LocalChanges'}
            data-type='PerspectiveButton'
            rightIcon='caret-down'
            text={
              <div className={css.text}>
                <span>{strings.modifiedItems}</span>
                {catalogItemsWithUnsavedChanges.length > 0 && <NumberBadge className={classNames(css.count)} children={catalogItemsWithUnsavedChanges.length}/>}
              </div>}
    />
  </Popover2>)
})


// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/PerspectiveButtons.tsx